module.exports = __webpack_public_path__ + "static/img/zszq-bg.e6198a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zszq-bg.png
// module id = 7TO1
// module chunks = 3